import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=9f7b9f92&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=9f7b9f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7b9f92",
  null
  
)

export default component.exports